import html2canvas from "html2canvas";

export const takeScreenshot = (template) => {
  return new Promise((resolve, reject) => {
    let node: any = undefined;
    if (template?.isLegacy == true) {
      node = document.querySelector("#template-container center table.container") as any;
    } else {
      node = document.querySelector("#template-container center table.main") as any;
    }
    html2canvas(node, {
      allowTaint: true,
      useCORS: true,
    }).then(function (canvas) {
      var croppedCanvas = document.createElement("canvas");
      var croppedCanvasContext = croppedCanvas.getContext("2d") as any;

      var cropPositionTop = 0;
      var cropPositionLeft = 0;
      var cropWidth = canvas.width;
      var cropHeight = canvas.height;
      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeight;
      croppedCanvasContext.drawImage(canvas, cropPositionLeft, cropPositionTop);
      resolve(croppedCanvas.toDataURL("image/png"));
    });
  });
};
